import AppColors from "general/constants/AppColors";
import UIHelper from "general/helpers/UIHelper";

const BreadcrumbHelper = {
  // ---- methods ----

  setBreadcrumPath: (breadcrum, path) => {
    let breadcrumPath = localStorage.getItem('breadcrumPath');

    if (breadcrumPath) {
      breadcrumPath = JSON.parse(breadcrumPath);
    } else {
      breadcrumPath = [];
    }

    const isPathExist = breadcrumPath.some((item) => item.breadcrum === breadcrum);

    if (!isPathExist) {
      breadcrumPath.push({ breadcrum, path });
      localStorage.setItem('breadcrumPath', JSON.stringify(breadcrumPath));
      localStorage.setItem('breadcrumPathHistory', JSON.stringify(breadcrumPath));
    }
  },

  setBreadcrumPathOnly: (items) => {
    let breadcrumPathOnly = [];

    items?.forEach((item) => {
      breadcrumPathOnly.push({ breadcrum: item.breadcrum, path: item.path });
    });

    localStorage.setItem('breadcrumPath', JSON.stringify(breadcrumPathOnly));
  },

  removeBreadcrumbPathHistory: () => {
    localStorage.removeItem('breadcrumPathHistory');
  },

  removeBreadcrumbPath: () => {
    localStorage.removeItem('breadcrumPath');
  },

  buildBreadcrumb: (items) => {
    return (
      <nav aria-label="ui-breadcrumb" >
        <ol
          className="breadcrumb bg-white px-5"
          style={{
            borderBottom: `1px solid ${AppColors.gray[300]}`,
          }}
        >
          {items.map((item, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${index === items.length - 1 ? 'active' : 'cursor-pointer'
                }`}
              aria-current={index === items.length - 1 ? 'page' : ''}
              style={
                (index !== items.length - 1 &&
                  UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])) ||
                UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])
              }
              onClick={item?.onPress}
            >
              {item?.title}
            </li>
          ))}
        </ol>
      </nav>
    );
  },
};

export default BreadcrumbHelper;
